import React from 'react'
import Breadcrumb from '../../../../Components/Utils/Breadcrumb'
import { BackButton } from '../../../../Components/Utils/Buttons'
import PurchaseRequestPermission from './PurchaseRequestPermission'

import PurchaseOrderPermission from './PurchaseOrderPermission'

import TCpremission from './TCpremission'
import RefillingPremission from './RefillingPremission'
import InvoiceOutgoingPremission from './InvoiceOutgoingPremission'
import { ShieldCheck } from 'lucide-react'
import { TextMediumBase } from '../../../../Components/Text/MediumText'
import { HeadingWithIcon } from '../../../../Components/Utils/Settingheading'

function MainStatusPermission() {
    return(
        <div className='w-full h-full px-4 py-2'>
          <div className='w-full flex justify-between items-center'>
          <Breadcrumb
            items={[
              {
                name: "Settings",
              },
              {
                name: "Approval Permission"
              }
            ]}
          />
          <BackButton/>
          </div>
          <div className="w-full h-[calc(100vh-145px)]  mt-3 mx-auto rounded-md overflow-y-scroll">
            <div className=''>
         <div className="sticky top-0 z-40 bg-white p-4 border-b border-slate-200">
 
             <HeadingWithIcon icon={ShieldCheck} title="Approval Permission" />

  </div>
          <div className="p-3 bg-white shadow-md rounded-b-lg">
              <PurchaseOrderPermission/>
          </div>
                    <div className="p-3 mt-4 bg-white shadow-md rounded-lg">
    <PurchaseRequestPermission/>
          </div>
                    <div className="p-3 mt-4 bg-white shadow-md rounded-lg">
    <TCpremission/>
          </div>
                    <div className="p-3 mt-4 bg-white shadow-md rounded-lg">
    <RefillingPremission/>
          </div>
                    <div className="p-3 mt-4 bg-white shadow-md rounded-lg">
    <InvoiceOutgoingPremission/>
          </div>
          </div>
        
          </div>
          </div>
      )
}

export default MainStatusPermission